export default __webpack_public_path__ + "static/media/NocheLuna.ebce3ba4.svg";